module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-1-large-208427b392b00148c4abcf77c3d2728a.jpg";